import { STATUS_CODE } from '../constants';
import { META_STATUS_CODE } from '../constants/metaStatusCode';

import type { StatusCode } from '../constants';
import type { MetaStatusCode } from '../constants/metaStatusCode';

/**
 * Meta API에서 반환된 상태 코드를 콘솔 상태 코드(StatusCode)로 변환합니다.
 * @description
 * - Meta API에서 반환된 상태 코드를 콘솔에서 사용하는 표준 상태 코드로 매핑합니다.
 * - 매핑되지 않는 코드는 INTERNAL_SERVER_ERROR를 반환합니다.
 * @example
 * // Meta 상태 코드를 애플리케이션 상태 코드로 변환
 * const statusCode = getStatusCodeByMetaStatusCode(META_STATUS_CODE.NOT_FOUND_SERVICE);
 * // statusCode === STATUS_CODE.NOT_FOUND_SERVICE
 */
export function getStatusCodeByMetaStatusCode(
  metaStatusCode?: MetaStatusCode,
): StatusCode | undefined {
  switch (metaStatusCode) {
    case META_STATUS_CODE.NOT_FOUND_SERVICE:
      return STATUS_CODE.NOT_FOUND_SERVICE;
    case META_STATUS_CODE.NOT_FOUND_ROUTE:
      return STATUS_CODE.NOT_FOUND_ROUTE;
    default:
      return STATUS_CODE.INTERNAL_SERVER_ERROR;
  }
}
